import type { CSSProperties } from "react";
import moment from "moment";
import { DATE_TIME_FORMAT, PAYMENT_STATUS } from "./constants";

export const PAYMENT_STATUS_BADGE_CONFIG: Record<
  number,
  { label: string; className: string; style?: CSSProperties }
> = {
  [PAYMENT_STATUS.UNPAID]: {
    label: "Chưa thanh toán",
    className: "invoice-status-5",
  },
  [PAYMENT_STATUS.PAID]: {
    label: "Thanh toán đủ",
    className: "invoice-status-0",
  },
  [PAYMENT_STATUS.UNDERPAID]: {
    label: "Thanh toán thiếu",
    className: "invoice-status",
    style: {
      backgroundColor: "#d4edf7",
      color: "#0069b4",
    },
  },
  [PAYMENT_STATUS.OVERPAID]: {
    label: "Thanh toán thừa",
    className: "invoice-status-4",
  },
};

const LIST_PAID_PAYMENT_STATUSES = new Set<number>([
  PAYMENT_STATUS.PAID,
  PAYMENT_STATUS.UNDERPAID,
  PAYMENT_STATUS.OVERPAID,
]);

export const formatPaymentAmountVnd = (value: unknown) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const numberValue =
    typeof value === "number"
      ? value
      : typeof value === "string"
        ? Number(value)
        : NaN;

  if (!Number.isFinite(numberValue)) {
    return String(value);
  }

  return new Intl.NumberFormat("vi-VN").format(numberValue);
};

export const formatPaymentDateTime = (value: unknown) => {
  if (!value) {
    return "";
  }

  return moment(value).format(DATE_TIME_FORMAT);
};

export const renderListPaymentStatusBadge = (
  status: number | null | undefined,
) => {
  if (
    status === null ||
    status === undefined ||
    !LIST_PAID_PAYMENT_STATUSES.has(status)
  ) {
    return null;
  }

  return (
    <span className="underline invoice-status invoice-status-0">
      Đã thanh toán
    </span>
  );
};

export const renderInvoicePaymentStatusBadge = (
  status: number | null | undefined,
) => {
  const current =
    status !== null && status !== undefined
      ? PAYMENT_STATUS_BADGE_CONFIG[status]
      : undefined;

  if (!current) {
    return null;
  }

  return (
    <span
      className={`invoice-status ${current.className}`}
      style={current.style}
    >
      {current.label}
    </span>
  );
};
